import React from 'react'
import PropTypes from 'prop-types'
import { List, Map, fromJS } from 'immutable'
import { DateRange } from 'react-date-range'
import moment from 'moment'
import { stopEvent } from '@aytm/lib/common/func'
import { PureDataComponent } from '@aytm/lib/common/components/pure-component'
import Label from '@aytm/lib/rfd-ui/components/basic/label'

import '@aytm/lib/rfd-ui/styles/advanced/date-range-picker.scss'

const THEME = {
  DateRange: {
    background: '#ffffff',
    fontSize: '16px',
    width: '563px'
  },
  Calendar: {
    background: '#ffffff',
    color: '#555555',
    fontSize: '16px',
    padding: '9px',
    width: '281px'
  },
  Day: {
    fontSize: '16px',
    transition: 'transform .1s ease, box-shadow .1s ease, background .1s ease'
  },
  DayInRange: {
    background: '#E6E7E8',
    color: '#555555',
    fontSize: '16px'
  },
  DaySelected: {
    background: '#29ABE2',
    fontSize: '16px'
  },
  DayHover: {
    background: '#555555',
    color: '#ffffff',
    fontSize: '16px'
  },
  Weekday: {
    background: '#ffffff',
    fontSize: '16px',
    color: '#4D4D4D'
  },
  MonthAndYear: {
    background: '#ffffff',
    fontSize: '16px',
    color: '#4D4D4D'
  },
  MonthArrowPrev: {
    borderRightColor: '#4D4D4D'
  },
  MonthArrowNext: {
    borderLeftColor: '#4D4D4D'
  },
  MonthButton: {
    background: '#FFFFFF'
  }
}

export function refreshDates(index) {
  const dates = fromJS([
    {
      text: 'TODAY',
      from: moment(),
      to: moment(),
      index: 0
    },
    {
      text: 'THIS MONTH',
      from: moment().startOf('month'),
      to: moment(),
      index: 1
    },
    {
      text: 'PREVIOUS MONTH',
      from: moment().subtract(1, 'months').startOf('month'),
      to: moment().subtract(1, 'months').endOf('month'),
      index: 2
    },
    {
      text: 'LAST 3 MONTHS',
      from: moment().subtract(3, 'months').endOf('month'),
      to: moment(),
      index: 3
    },
    {
      text: 'THIS YEAR',
      from: moment().startOf('year'),
      to: moment(),
      index: 4
    },
    {
      text: 'LAST YEAR',
      from: moment().subtract(1, 'years').startOf('year'),
      to: moment().subtract(1, 'years').endOf('year'),
      index: 5
    }
  ])

  if (index && index >= 0) return dates.get(index)
  return dates
}

export default class DateRangePicker extends PureDataComponent {
  static propTypes = {
    detached: PropTypes.bool.isRequired,
    placeholder: PropTypes.string,
    buttons: PropTypes.oneOfType([PropTypes.instanceOf(List), PropTypes.array]),
    from: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    detachedWidth: PropTypes.number,
    empty: PropTypes.bool,
    left: PropTypes.bool,
    hideOnChange: PropTypes.bool,
    applyOnHide: PropTypes.bool,
    onChange: PropTypes.func,
    onApply: PropTypes.func,
    className: PropTypes.string
  }

  constructor(props) {
    super(props)

    this.showPicker = this.showPicker.bind(this);
    this.clearState = this.clearState.bind(this);
    this.hidePicker = this.hidePicker.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onApply = this.onApply.bind(this);
    this.setRange = this.setRange.bind(this);

    this.buttons = props.buttons ? (List.isList(props.buttons) ? props.buttons : fromJS(props.buttons)) : refreshDates()

    this.picker = null
    this.rangeSet = false
    this.style = null
    this.link = null

    this.listener = event => {
      if ((!this.link || !this.link.contains(event.target)) && (!this.picker || !this.picker.contains(event.target))) {
        this.hidePicker()
      }
    }

    this.state = {
      shown: false,
      from: props.from ? ('object' == typeof props.from ? props.from : moment(props.from)) : moment(),
      to: props.to ? ('object' == typeof props.to ? props.to : moment(props.to)) : moment(),
      detachedValue: props.placeholder
    }
  }

  componentDidMount() {
    super.componentDidMount()
    // if (this.link) {
    //   const el = this.link.querySelectorAll(':first-child')[0]
    //   this.style = {
    //     left:
    //       this.link.offsetLeft - this.link.scrollLeft + (this.props.left ? el.getBoundingClientRect().width - 742 : 0),
    //     top: this.link.offsetTop - this.link.scrollTop,
    //     marginTop: el.getBoundingClientRect().height
    //   }
    // }
  }

  showPicker() {
    if (this.link) {
      const el = this.link.querySelectorAll(':first-child')[0]
      this.style = {
        left:
          this.link.offsetLeft - this.link.scrollLeft + (this.props.left ? el.getBoundingClientRect().width - 742 : 0),
        top: this.link.offsetTop - this.link.scrollTop,
        marginTop: el.getBoundingClientRect().height
      }
    }
    document.addEventListener('click', this.listener)
    this.setState({ shown: true })
  }

  clearState() {
    this.setState({
      shown: false,
      from: this.props.from
        ? 'object' == typeof this.props.from
          ? this.props.from
          : moment(this.props.from)
        : moment(),
      to: this.props.to ? ('object' == typeof this.props.to ? this.props.to : moment(this.props.to)) : moment(),
      detachedValue: this.props.placeholder
    })
  }

  hidePicker() {
    this.setState({ shown: false })

    this.props.applyOnHide &&
      this.props.onChange &&
      'function' == typeof this.props.onChange &&
      this.props.onChange(
        Map({
          from: this.state.from,
          to: this.state.to,
          text: this.state.detachedValue
        })
      )

    document.removeEventListener('click', this.listener)
  }

  onChange(range) {
    range.startDate != range.endDate && this.props.hideOnChange && this.hidePicker()

    !this.props.applyOnHide &&
      this.props.onChange &&
      'function' == typeof this.props.onChange &&
      this.props.onChange(
        Map({
          from: this.state.from,
          to: this.state.to,
          text: this.state.detachedValue
        })
      )

    this.setState({
      from: range.startDate,
      to: range.endDate
    })

    this.props.detached &&
      !this.rangeSet &&
      this.setState({
        detachedValue: `${range.startDate.format('MMM DD, YYYY')} - ${range.endDate.format('MMM DD, YYYY')}`
      })
    this.rangeSet = false
  }

  onApply(button) {
    const applyMap = Map.isMap(button)
      ? button
      : Map({
          from: this.state.from,
          to: this.state.to,
          text: this.state.detachedValue
        })

    !this.props.applyOnHide &&
      this.props.onApply &&
      'function' == typeof this.props.onApply &&
      this.props.onApply(applyMap)

    this.hidePicker()
    this.setState({ detachedValue: this.props.placeholder })
  }

  setRange(event) {
    stopEvent(event)

    const optionIndex = event.target ? event.target.dataset.index : null
    this.buttons = refreshDates()
    const button = this.buttons.get(optionIndex) ? this.buttons.get(optionIndex) : null

    this.setState({
      from: button.get('from'),
      to: button.get('to')
    })

    this.rangeSet = true
    this.props.detached && this.setState({ detachedValue: button.get('text').toUpperCase() })

    !this.props.applyOnHide &&
      this.props.onApply &&
      'function' == typeof this.props.onApply &&
      this.props.onApply(button)
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.mounted && nextProps.empty && this.clearState()
  }

  renderPicker() {
    const { shown, from, to } = this.state
    const { onApply, className = '' } = this.props

    return (
      <div>
        {shown && (
          <div
            className={`rfd-ui-date-range-picker-calendar ${className}`}
            ref={el => {
              this.picker = el
            }}
            style={this.style}
          >
            <i className="icon-aytmfd-delete" onClick={this.hidePicker} />
            <div className="rfd-ui-date-range-picker-calendar-header">
              {(() =>
                this.buttons.map((o, oi) => (
                  <a
                    className="rfd-ui-button"
                    key={oi}
                    data-index={oi}
                    onClick={this.setRange}
                    dangerouslySetInnerHTML={{ __html: o.get('text') }}
                  />
                )))()}
            </div>
            <DateRange startDate={from} endDate={to} onChange={this.onChange} theme={THEME} linkedCalendars={true} />
            {onApply && (
              <a className="rfd-ui-button apply-button" onClick={this.onApply}>
                APPLY
              </a>
            )}
          </div>
        )}
      </div>
    )
  }

  renderAttached() {
    return (
      <div>
        <div
          className="rfd-ui-date-range-picker-link"
          ref={div => {
            this.link = div
          }}
          onClick={this.showPicker}
        >
          {this.props.children}
        </div>
        {this.renderPicker()}
      </div>
    )
  }

  renderDetached() {
    return (
      <div>
        <div
          className="rfd-ui-date-range-picker-link"
          ref={div => {
            this.link = div
          }}
          onClick={this.showPicker}
        >
          <Label
            icon="calendar"
            withArrow={true}
            placeholder={this.state.detachedValue}
            width={this.props.detachedWidth ? this.props.detachedWidth : 231}
          />
        </div>
        {this.renderPicker()}
      </div>
    )
  }

  render() {
    return (
      <div className="rfd-ui-date-range-picker">
        {this.props.detached ? this.renderDetached() : this.renderAttached()}
      </div>
    )
  }
}
